import type { CmsFormSubmissionValues } from '@/services/cms/CmsFormSubmissionData';
import type { CmsEditableField } from '@/services/cms/userDefinedForm/CmsEditableField';

const ignoredFields = new Set(['EditableFormStep', 'EditableFieldGroup', 'EditableFieldGroupEnd']);

export function extractDefaultValues(fields: CmsEditableField[]) {
    const values: Record<string, CmsFormSubmissionValues> = {};

    for (const field of fields) {
        if (ignoredFields.has(field.className)) {
            continue;
        }
        if (field.className === 'EditableRadioField' || field.className === 'EditableDropdown') {
            const defaultOption = field.options?.find((option) => option.default);
            values[field.name] = defaultOption?.value || undefined;
            continue;
        }
        if (field.className === 'EditableCheckboxGroupField') {
            const defaultOptions = field.options?.filter((option) => option.default).map((option) => option.value);
            if (defaultOptions?.length) {
                values[field.name] = defaultOptions;
            }
            continue;
        }
        if (field.className === 'EditableDateField') {
            values[field.name] = field.defaultToToday ? new Date() : field.default || undefined;
            continue;
        }

        if (field.className === 'EditableNumericField') {
            values[field.name] = null;
            continue;
        }
        if (field.className === 'EditableCheckbox') {
            values[field.name] = field.checkedDefault;
            continue;
        }

        values[field.name] = field.default || '';
    }
    return values;
}
